 
<div class="card">
  <div *ngIf="!isLoaded" class="spinner-border ms-3 mt-3 mb-3" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
<div id="grid-container" class="card-body" *ngIf="isLoaded">
  <angular-slickgrid gridId="gridLogs"
            [columnDefinitions]="columnDefinitions"
            [gridOptions]="gridOptions"
            [dataset]="dataset">
  </angular-slickgrid>
</div>
</div>
